"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describeDiskSpecification = describeDiskSpecification;
exports.describeSoldout = describeSoldout;
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var axios = new _axios.default({
  extra: {
    componentName: 'diskPackage'
  }
});

//查询云盘支持的规格
function describeDiskSpecification(regionId) {
  return axios({
    url: '/openApi/disk/describeDiskSpecification',
    method: 'GET',
    params: {
      regionId: regionId
    }
  });
}
//查询云盘支持的规格的售罄情况
function describeSoldout(regionId) {
  return axios({
    url: '/openApi/disk/describeSoldout',
    method: 'GET',
    params: {
      regionId: regionId
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/cloud-disk-pack.js
// module id = gKoO
// module chunks = 19